import { render } from "./NextSvg.vue?vue&type=template&id=700b1377"
import script from "./NextSvg.vue?vue&type=script&lang=js"
export * from "./NextSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__